import { forwardRef } from 'react';

const variants = {
  primary: 'bg-[var(--color-warm-900)] text-[var(--color-cream-50)] hover:bg-[var(--color-warm-800)] active:bg-[var(--color-warm-900)] shadow-[var(--shadow-xs)] hover:shadow-[var(--shadow-sm)]',
  secondary: 'bg-[var(--color-cream-50)] text-[var(--color-warm-800)] border border-[var(--color-warm-200)] hover:bg-[var(--color-cream-200)] hover:border-[var(--color-warm-300)]',
  ghost: 'bg-transparent text-[var(--color-warm-700)] hover:bg-[var(--color-cream-200)] hover:text-[var(--color-warm-900)]',
  destructive: 'bg-[var(--color-danger-500)] text-white hover:bg-[var(--color-danger-600)] shadow-[var(--shadow-xs)]',
  accent: 'bg-[var(--color-recovery-500)] text-white hover:bg-[var(--color-recovery-600)] shadow-[var(--shadow-xs)]',
  action: 'bg-[var(--color-action-500)] text-white hover:bg-[var(--color-action-600)] shadow-[var(--shadow-xs)]',
};

const sizes = {
  sm: 'h-8 px-3 text-[13px] gap-1.5 rounded-[var(--radius-sm)]',
  md: 'h-10 px-4 text-sm gap-2 rounded-[var(--radius-md)]',
  lg: 'h-12 px-5 text-[15px] gap-2.5 rounded-[var(--radius-md)]',
};

const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled = false,
    leftIcon,
    rightIcon,
    className = '',
    children,
    ...props
  },
  ref
) {
  const isDisabled = disabled || loading;
  return (
    <button
      ref={ref}
      disabled={isDisabled}
      className={`
        inline-flex items-center justify-center font-semibold
        transition-all duration-150 ease-out
        disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {loading ? (
        <Spinner />
      ) : (
        leftIcon && <span className="shrink-0">{leftIcon}</span>
      )}
      {children && <span className="truncate">{children}</span>}
      {!loading && rightIcon && <span className="shrink-0">{rightIcon}</span>}
    </button>
  );
});

function Spinner() {
  return (
    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export default Button;
